import { request, downloadFile } from './client';

export const apiGetAllOrders = (page = 1, limit = 10, status = '', search = '') => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (status) params.set('status', status);
  if (search) params.set('search', search);
  return request(`/orders/admin/all?${params}`);
};

export const apiUpdateOrderStatus = (orderId, status, shippingDetails = {}) =>
  request(`/orders/admin/${orderId}/status`, {
    method: 'PUT',
    body: { status, ...shippingDetails },
  });

export const apiDownloadInvoice = (orderId) =>
  downloadFile(`/orders/${orderId}/invoice`, `invoice-${orderId}.pdf`);

export const apiDownloadOrderReport = (days, status = '') => {
  const params = new URLSearchParams({ days: String(days) });
  if (status) params.set('status', status);
  return downloadFile(`/orders/admin/report?${params}`, `orders-last-${days}-days.xlsx`);
};
